import axios from "axios";
import { API_URL } from "../Config";
import authHeader from "./auth-header";

const list = (values) => {
  return axios.get(API_URL + "lab", {
    headers: authHeader(),
    params: values,
  });
};
const detail = (lab_order_id) => {
  return axios.get(API_URL + `lab/detail/${lab_order_id}`, {
    headers: authHeader(),
  });
};

const labService = { list, detail };

export default labService;
